<template>
	<div>
		<h1>{{ title }}</h1>
		<div class="tag-sections">
			<section class="tag">
				<div class="font-weight-extra-bold">Mehrfachauswahl möglich</div>
				<CharacteristicSelectInline
					v-model="careerLevels"
					:characteristic-items="meta.careerLevel"
					:initial-amount="9"
					label-type="application"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import {mapState} from "vuex";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";

export default {

	components: {
		RadioGroup,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
	},

	data ()
	{
		return {
			careerLevels: this.value?.careerLevels,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		careerLevelsValid ()
		{
			return (isDefined(this.careerLevels) && arrayIsNotEmpty(this.careerLevels));
		},
		valid ()
		{
			return this.careerLevelsValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				careerLevels: this.careerLevels,
				valid: this.valid,
			});
		}
	},
}
</script>
